import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ComponentRef, OnDestroy, ViewChild, ViewContainerRef } from '@angular/core';
import { XMLElementBaseComponent } from '../base';
import { Explanation } from '../volkswagen.types';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-vw-explanation',
  imports: [CommonModule, TranslocoPipe],
  standalone: true,
  template: `
    @if (data.text && data.ziel) {
      <br />
      <br />
      <span class="font-bold">
        {{ data.text }}
      </span>

      <!-- TODO: !!!!!!!!!!!!!!!!!!!! -->
      <p class="cursor-not-allowed text-blue-800 hover:underline">
        <i class="pi pi-arrow-right pr-2 !text-[10px]"></i>
        {{ 'documents.vw.seeHere' | transloco }} {{ data.ziel }}
      </p>
    } @else if (data.text) {
      <span>
        {{ data.text }}
      </span>
    } @else if (!data.text && data.ziel) {
      <span>
        {{ data.ziel }}
      </span>
    }

    <ng-template #childrenContainer></ng-template>

    <!-- <div class="bg-slate-50 text-xs">{{ data | json }}</div> -->
  `,
})
export class ExplanationComponent extends XMLElementBaseComponent<Explanation> implements AfterViewInit, OnDestroy {
  @ViewChild('childrenContainer', { read: ViewContainerRef })
  childrenContainer!: ViewContainerRef;

  private childComponents: ComponentRef<XMLElementBaseComponent>[] = [];

  ngAfterViewInit() {
    if (this.data?.children && this.childrenContainer) {
      this.childRenderService.setProvider(this.provider);
      this.childComponents = this.childRenderService.renderChildren(this.data.children, this.childrenContainer);
    }
  }

  ngOnDestroy() {
    this.childComponents.forEach((ref) => ref.destroy());
  }
}
